module.exports = __webpack_public_path__ + "img/Fanning-RQ-t-19935-009.9e061e85.jpg";